export default __webpack_public_path__ + "static/white-car-1ab1f3b477ab227f399e2f0440e53b6a.png";